import { render, staticRenderFns } from "./ModalNovoUsuario.vue?vue&type=template&id=6efd3eaa"
import script from "./ModalNovoUsuario.vue?vue&type=script&lang=ts"
export * from "./ModalNovoUsuario.vue?vue&type=script&lang=ts"
import style0 from "./ModalNovoUsuario.vue?vue&type=style&index=0&id=6efd3eaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports